import { User } from 'types/user';

const isUserMyClubManager = (user: User) => user?.isMcManager;

export default isUserMyClubManager;
